import React, { FC, useRef } from 'react';

import {
	BUTTON_TYPES,
	ChevronUp,
	DropdownPosition,
	EvDropdownMenu,
	EvSvgIcon,
	IDropdownMenuOption
} from '@evinced-private/ui-common';

import './ExportDropdownMenu.scss';

interface IExportDropdownMenuProps {
	dropdownId: string;
	dropdownOptions: IDropdownMenuOption[];
	className?: string;
	disabled?: boolean;
	loading?: boolean;
}

export const ExportDropdownMenu: FC<IExportDropdownMenuProps> = ({
	dropdownId,
	dropdownOptions,
	className,
	disabled = false,
	loading = false
}) => {
	const downloadBtnRef = useRef(null);

	return (
		<EvDropdownMenu
			className={`export-dropdown-menu ${className}`}
			id={dropdownId}
			options={dropdownOptions}
			position={DropdownPosition.BOTTOM_LEFT}
			disabled={disabled}
			loading={loading}
			triggerButtonProps={{
				ref: downloadBtnRef,
				type: BUTTON_TYPES.SECONDARY,
				ariaHaspopup: 'menu',
				dataAutomationId: 'export-dropdown-button',
				srLoadingMessage: 'API JSON report is loading, please wait',
				children: (
					<>
						Export
						<div className="menu-trigger-icon">
							<EvSvgIcon icon={ChevronUp} isSmall />
						</div>
					</>
				)
			}}
		/>
	);
};
